import {GetKeyResultMeetingHistory,
    GetKeyResultMeetingHistory1,
    GetAllTeamChildByParentId,
    GetAllPersonMeetingByParentId,
    addCheckinMeeting,
    addCommitments,
    addCommitmentsCheckinMeeting,
    addCheckinBAUMeeting,
    GetKeyResultHistoryCheckinByKeyResultId,
    GetAllCommitments,
    GetAllCommitmentsByPeriodId,
    GetBAUHistoryCheckinByIdQuery,
    likeMeeting,
    GetCommitMeetingHistory,
    getTeamDetail,
    GetBAUMeetingHistory,
    disAddDisLikeMeetingKeyResult,
    addDeterminingSituationAlignmentMeeting,
    AddLikeMeetingKeyResult,
    disLikeMeeting,
    getMyKeyResultByTenantId
} from '../Api/index';
import { useDispatch } from 'react-redux';
import { setAddKrStatusDataR } from '../../Meeting/MeetingsSlice/MeetingsSlice';
import { useMutation, useQuery } from 'react-query';
import { v4 as uuidv4 } from 'uuid';
import { useQueryClient } from 'react-query';
import { getAlignmentMeetingDetailByTeamId } from '../../Meeting/Api/Index';

const useGetKeyResultMeetingHistory=(krId:string|null,prId:string|null,meetId:string|null)=>{
return useQuery(['GetKeyResultMeetingHistory',krId,prId,meetId],GetKeyResultMeetingHistory,{
    refetchOnWindowFocus:false,
    cacheTime:Infinity,
    enabled:!!krId
    ,
    onError:(err)=>{
    //  console.log(err)
    }
    ,
    onSuccess:(data)=>{
    // console.log(data)
    },
    select:(data:any)=>{
    let rawData=data?.data.data;
    let transed=rawData.map((hr:any)=>{
    return{id:uuidv4(),...hr}
    })
   
    return transed
    }

})
}

const useGetKeyResultMeetingHistory1=(krId:string|null,prId:string|null,meetId:string|null)=>{
  return useQuery(['GetKeyResultMeetingHistory1',krId,prId,meetId],GetKeyResultMeetingHistory1,{
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      enabled:!!krId
      ,
      onError:(err)=>{
      //  console.log(err)
      }
      ,
      onSuccess:(data)=>{
      // console.log(data)
      },
      select:(data:any)=>{
      let rawData=data?.data.data;
      let transed=rawData.map((hr:any)=>{
      return{id:uuidv4(),...hr}
      })
     
      return transed
      }
  
  })
  }

const useGetBAUMeetingHistory=(krId:string|null,prId:string|null,meetId:string|null)=>{
  return useQuery(['GetBAUMeetingHistory',krId,prId,meetId],GetBAUMeetingHistory,{
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      enabled:!!krId
      ,
      onError:(err)=>{
      //  console.log(err)
      }
      ,
      onSuccess:(data)=>{
      // console.log(data)
      },
      select:(data:any)=>{
      let rawData=data?.data.data;
      let transed=rawData.map((hr:any)=>{
      return{id:uuidv4(),...hr}
      })
     
      return transed
      }
  
  })
  }

const useGetCommitMeetingHistory=(meetingId:string|null,id:string|null)=>{
  return useQuery(['GetCommitMeetingHistory',meetingId,id],GetCommitMeetingHistory,{
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      enabled:!!meetingId
      ,
      onError:(err)=>{
      //  console.log(err)
      }
      ,
      onSuccess:(data)=>{
      // console.log(data)
      },
      select:(data:any)=>{
      let rawData=data?.data.data;
      let transed=rawData.map((hr:any)=>{
      return{id:uuidv4(),...hr}
      })
     
      return transed
      }
  
  })
  }
  
const useGetAllTeamChildByParentId=(teamId:string | null,meetingId:string | null,priodId:string | null)=>{
    let ids={teamId:teamId,meetingId:meetingId,priodId:priodId}
    return useQuery(['GetAllTeamChildByParentId',ids],GetAllTeamChildByParentId,{
    enabled:!!ids,
    cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onError:(err)=>{
    // console.log(err)
    }
    ,
    select:(data:any)=>{
        let rawData=data?.data.data;
        return rawData
       }
    })
}; 

const useGetAllPersonMeetingByParentId=(teamId:string | null,meetingId:string | null,priodId:string | null)=>{
  let ids={teamId:teamId,meetingId:meetingId,priodId:priodId}
  return useQuery(['GetAllPersonMeetingByParentId',ids],GetAllPersonMeetingByParentId,{
  enabled:!!ids,
  cacheTime:Infinity,
  refetchOnWindowFocus:false,
  onError:(err)=>{
  // console.log(err)
  }
  ,
  select:(data:any)=>{
      let rawData=data?.data.data;
      return rawData
     }
  })
}; 

const useLikeMeeting = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (userData: any) =>  likeMeeting(userData),
      onSuccess: (data: any) => {
      },
    });
  };
  const useDisLikeMeeting = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (userData: any) => disLikeMeeting(userData),
      onSuccess: (data: any) => {
      },
    });
  };
  

  const useAddLikeMeetingKeyResult = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (userData: any) =>  AddLikeMeetingKeyResult(userData),
      onSuccess: (data: any) => {
      },
    });
  };
  const useAddDisLikeMeetingKeyResult = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (userData: any) => disAddDisLikeMeetingKeyResult(userData),
      onSuccess: (data: any) => {
      },
    });
  };



// const useAddCheckinMeeting=(addCheckinSuccess:any)=>{
//     const dispatch=useDispatch();
//     const queryClient=useQueryClient()
//     return useMutation({
//   mutationFn: (checkinData:any) =>AddCheckinMeeting(checkinData),
//   onSuccess: (data:any) => {
//     dispatch(setAddKrStatusDataR(data?.data))
//         addCheckinSuccess()

 
//   },
// });
//    }

// const useAddCheckinMeeting=(addCheckinSuccess:any)=>{
//     const dispatch=useDispatch();
//     const queryClient=useQueryClient()
//       return useMutation({
//     mutationFn: (data:any) =>AddCheckinMeeting(data),
//     onSuccess: (data) => {

//         dispatch(setAddKrStatusDataR(data?.data))
//         addCheckinSuccess()

//         // queryClient.invalidateQueries('getObjectiveDetails')
//         // localEditKrSuccess()
//     //   console.log(data)
//     },
//   });
// }

const useAddCheckinMeeting=()=>{
        // const dispatch=useDispatch();
    // const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (data:any) =>addCheckinMeeting(data),
    onSuccess: (data) => {
        // console.log(data)
        // addSucess()
        // dispatch(setAddKrStatusDataR(data?.data))
        // addCheckinSuccess()
    },
  });
}

const useAddCommitmentsCheckinMeeting=()=>{
  // const dispatch=useDispatch();
// const queryClient=useQueryClient()
return useMutation({
mutationFn: (data:any) =>addCommitmentsCheckinMeeting(data),
onSuccess: (data) => {
  // console.log(data)
  // addSucess()
  // dispatch(setAddKrStatusDataR(data?.data))
  // addCheckinSuccess()
},
});
}

const useAddCommitments=()=>{
  // const dispatch=useDispatch();
const queryClient=useQueryClient()
return useMutation({
mutationFn: (data:any) =>addCommitments(data),
onSuccess: (data) => {
  queryClient.invalidateQueries("GetAllCommitments");
  // console.log(data)
  // addSucess()
  // dispatch(setAddKrStatusDataR(data?.data))
  // addCheckinSuccess()
},
});
}

const useAddDeterminingSituationAlignmentMeeting=()=>{
  // const dispatch=useDispatch();
const queryClient=useQueryClient()
return useMutation({
mutationFn: (data:any) =>addDeterminingSituationAlignmentMeeting(data),
onSuccess: (data) => {
  // console.log(data)
  // addSucess()
  queryClient.invalidateQueries("getAlignmentMeetingDetailByTeamId");
  queryClient.invalidateQueries("getAllCooperateByPersonId");
  // dispatch(setAddKrStatusDataR(data?.data))
  // addCheckinSuccess()
},
});
}

const useAddCheckinBAUMeeting=()=>{
  // const dispatch=useDispatch();
// const queryClient=useQueryClient()
return useMutation({
mutationFn: (data:any) =>addCheckinBAUMeeting(data),
onSuccess: (data) => {
  // console.log(data)
  // addSucess()
  // dispatch(setAddKrStatusDataR(data?.data))
  // addCheckinSuccess()
},
});
}

// const useAddObjective=(onSuccesss:any)=>{
//     const queryClient=useQueryClient()
    
//           return useMutation({
//         mutationFn: (data:any) =>
//             AddObjective(data),
//         onSuccess: (data) => {
//             onSuccesss()
//             queryClient.invalidateQueries('GetAllObjectiveByPeriodId')
//         //   console.log(data)
//         },
//       });
//      }





// const useAddTeam=()=>{
//     const queryClient=useQueryClient()
//           return useMutation({
//         mutationFn: (teamData:any) =>
//             addTeam(teamData),
//         onSuccess: (data) => {
//           queryClient.invalidateQueries('getAllTeams')
//         //  console.log(data)
//         },
//       });
//      }

const useGetAllCommitments=(tenantId: string | null, periodId:string)=>{
  // let ids={teamId:teamId,meetingId:meetingId,priodId:priodId}
  return useQuery(['GetAllCommitments',tenantId, periodId],GetAllCommitments,{
  enabled: !!tenantId,
  cacheTime:Infinity,
  refetchOnWindowFocus:false,
  onError:(err)=>{
  // console.log(err)
  }
  ,
  select:(data:any)=>{
      let rawData=data?.data?.data;
      return rawData
     }
  })
}

const useGetAllCommitmentsByPeriodId=(periodId:string)=>{
  // let ids={teamId:teamId,meetingId:meetingId,priodId:priodId}
  return useQuery(['GetAllCommitmentsByPeriodId',periodId],GetAllCommitmentsByPeriodId,{
  enabled: !!periodId,
  cacheTime:Infinity,
  refetchOnWindowFocus:false,
  onError:(err)=>{
  // console.log(err)
  }
  ,
  select:(data:any)=>{
      let rawData=data?.data?.data;
      return rawData
     }
  })
}



// (teamId:string | null,meetingId:string | null,priodId:string | null
const useGetKeyResultHistoryCheckinByKeyResultId=(formIds:any)=>{
    // let ids={teamId:teamId,meetingId:meetingId,priodId:priodId}
    return useQuery(['GetKeyResultHistoryCheckinByKeyResultId',formIds],GetKeyResultHistoryCheckinByKeyResultId,{
    enabled:!!formIds.keyResultId,
    cacheTime:Infinity,
    refetchOnWindowFocus:false,
    onError:(err)=>{
    // console.log(err)
    }
    ,
    select:(data:any)=>{
        let rawData=data?.data?.data;
        return rawData
       }
    })
}


const useGetBAUHistoryCheckinByIdQuery=(formIds:any)=>{
  // let ids={teamId:teamId,meetingId:meetingId,priodId:priodId}
  return useQuery(['GetBAUHistoryCheckinByIdQuery',formIds],GetBAUHistoryCheckinByIdQuery,{
  enabled:!!formIds.keyResultId,
  cacheTime:Infinity,
  refetchOnWindowFocus:false,
  onError:(err)=>{
  // console.log(err)
  }
  ,
  select:(data:any)=>{
      let rawData=data?.data?.data;
      return rawData
     }
  })
}

const useGetTeamDetail = (krId: string | null) => {
  return useQuery(["GetTeamDetail", krId], getTeamDetail, {
    enabled: !!krId,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data: any) => {
      console.log(data);
    },
    select: (data) => {
      let rawData = data?.data?.data;
      //  console.log(rawData)
      return rawData;
    },
  });
};


const useGetMyKeyResultsByTenantId=(periodId:string | null,profileTenantId:string | null,personId:string | null)=>{
  // console.log(periodId)
return useQuery(['GetMyKeyResultByTenantId',periodId,profileTenantId,personId],getMyKeyResultByTenantId,{
  enabled:!!periodId,
  // cacheTime:Infinity,
  refetchOnWindowFocus:false,
  onSuccess:(data:any)=>{
  // console.log(data)
  }
  ,onError:(err)=>{
  // console.log(err)
  } ,
  select:(data)=>{
  let rawData=data?.data?.data;
  return rawData
  }
})
}

export{
    useGetKeyResultMeetingHistory,
    useAddLikeMeetingKeyResult,
    useAddDisLikeMeetingKeyResult,
    useGetBAUMeetingHistory,
    useGetAllTeamChildByParentId,
    useGetAllPersonMeetingByParentId,
    useAddCheckinMeeting,
    useAddCommitments,
    useAddCheckinBAUMeeting,
    useGetKeyResultHistoryCheckinByKeyResultId,
    useGetCommitMeetingHistory,
    useGetBAUHistoryCheckinByIdQuery,
    useLikeMeeting,
    useGetTeamDetail,
    useGetKeyResultMeetingHistory1,
    useGetMyKeyResultsByTenantId,
    useDisLikeMeeting,
    useGetAllCommitments,
    useAddDeterminingSituationAlignmentMeeting,
    useAddCommitmentsCheckinMeeting,
    useGetAllCommitmentsByPeriodId
}